/* ==========================================================================
   custom-tlpc.js
   Scroll reveal for [data-tlpc-reveal] sections (see custom-tlpc.css §6).
   - Adds data-tlpc-reveal-ready to each root, then .is-visible to its
     .tlpc-anim children when they scroll into view.
   - Elements already in the viewport on load are shown immediately so the
     hero / LCP content is never hidden.
   - Does nothing when IntersectionObserver is unsupported or the visitor
     prefers reduced motion (content stays visible).
   ========================================================================== */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function inViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function setup(root) {
    if (!root || root.hasAttribute('data-tlpc-reveal-ready')) return;
    var items = root.querySelectorAll('.tlpc-anim');
    if (!items.length) return;

    items.forEach(function (el) {
      if (inViewport(el)) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
    root.setAttribute('data-tlpc-reveal-ready', '');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tlpc-reveal]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
